const city = "ogun"

const deliveryPrices = [
  {
    amount: 17500,
    label: "Intercity / Outside Ogun",
    value: "intercity",
    city,
  },
  {
    amount: 15500,
    label: "Other",
    value: "other",
    city,
  },
]

module.exports = deliveryPrices
